import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { routes } from '../../routes';

const BlogPage = lazy(() => import('./BlogPage'));
const BlogPostPage = lazy(() => import('./post'));

export const blogRoutes: RouteObject[] = [
  {
    path: `${routes.BLOG}/:id`,
    element: <BlogPostPage />,
  },
  {
    path: routes.BLOG,
    element: <BlogPage />,
  },
];
